import * as classnames from 'classnames'
import * as React from 'react'

import Logo from '../../atoms/Logo/Logo'
import OuterLink, { OuterLinkType } from '../../atoms/OuterLink/OuterLink'

import { buildOtherUrl } from '../../../../commons/utils'
import * as styles from './CommonFooter.css'

const CommonFooter = () => (
  <footer className={styles.footer}>
    <a href={buildOtherUrl('/')}>
      <div className={styles.logo}>
        <Logo />
      </div>
    </a>
    <div className={styles.links}>
      <OuterLink to={buildOtherUrl('/media/SBhMGcXw7SeO9QXUFh6oi')} type={OuterLinkType.NORMAL}>
        <p className={styles.text}>よくある質問</p>
      </OuterLink>
      <OuterLink to={buildOtherUrl('/privacy')} type={OuterLinkType.NORMAL}>
        <p className={classnames(styles.text, styles.center)}>プライバシーポリシー</p>
      </OuterLink>
      <OuterLink to={buildOtherUrl('/terms')} type={OuterLinkType.NORMAL}>
        <p className={styles.text}>利用規約</p>
      </OuterLink>
    </div>
    <p className={styles.copyRight}>©{new Date().getFullYear()} Ennoshita</p>
  </footer>
)

export default CommonFooter
